module.exports = __webpack_public_path__ + "static/media/mecca-namaz.b8297e71.gif";